import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" style={{ background: "var(--charcoal)", color: "#CFC6BF", padding: "60px 0 30px" }}>
      <div className="od-wrap" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 30 }}>
        <div>
          <div style={{ color: "var(--cream)", fontFamily: "'Fraunces', serif", fontSize: "1.3rem" }}>
            Olivia <i className="script" style={{ fontStyle: "normal" }}>Does</i>
          </div>
          <p style={{ maxWidth: 260, fontSize: ".85rem", color: "#B9AFA7", lineHeight: 1.6, marginTop: 12 }}>
            Care you notice. Standards you trust. A curated concierge for residential property care.
          </p>
        </div>
        <div style={{ display: "flex", gap: 60, flexWrap: "wrap" }}>
          <div>
            <b style={{ display: "block", color: "var(--cream)", fontSize: ".82rem", marginBottom: 12, letterSpacing: ".05em" }}>OLIVIA DOES</b>
            <Link to="/services" className="od-foot-link">Services</Link>
            <Link to="/trades" className="od-foot-link">Our trades</Link>
            <Link to="/about" className="od-foot-link">Our standard</Link>
            <Link to="/faqs" className="od-foot-link">FAQs</Link>
          </div>
          <div>
            <b style={{ display: "block", color: "var(--cream)", fontSize: ".82rem", marginBottom: 12, letterSpacing: ".05em" }}>PARTNERS</b>
            <Link to="/partners" className="od-foot-link">Partner with us</Link>
            <Link to="/partners" className="od-foot-link">Apply to join</Link>
          </div>
          <div>
            <b style={{ display: "block", color: "var(--cream)", fontSize: ".82rem", marginBottom: 12, letterSpacing: ".05em" }}>GET IN TOUCH</b>
            <Link to="/book" className="od-foot-link">Book a job</Link>
            <a href="mailto:hello@oliviadoes.co.uk" className="od-foot-link">hello@oliviadoes.co.uk</a>
          </div>
        </div>
      </div>
      <div className="od-wrap" style={{ borderTop: "1px solid #453E38", marginTop: 40, paddingTop: 20, fontSize: ".75rem", color: "#8B8078", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
        <span>© {new Date().getFullYear()} Olivia Does. One name your home can trust.</span>
        <span style={{ display: "flex", gap: 18 }}>
          <Link to="/terms" className="od-foot-link" style={{ display: "inline", marginBottom: 0 }}>Terms</Link>
          <Link to="/privacy" className="od-foot-link" style={{ display: "inline", marginBottom: 0 }}>Privacy</Link>
        </span>
      </div>
    </footer>
  );
}
